import wx from 'weixin-js-sdk' //微信sdk依赖
const jsApiList = ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline']
//要用到微信API
function getJSSDK(data, dataForWeixin) {
	wx.config({
		debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
		appId: data.appid, // 必填，公众号的唯一标识
		timestamp: data.timestamp, // 必填，生成签名的时间戳
		nonceStr: data.noncestr, // 必填，生成签名的随机串
		signature: data.signature, // 必填，签名
		jsApiList: jsApiList, // 必填，需要使用的JS接口列表
		openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-weapp']
		success: () => {
			console.log('success')
		},
	})
	wx.ready(function() {
		if (dataForWeixin) {
			wx.updateAppMessageShareData({
				title: dataForWeixin.title,
				desc: dataForWeixin.description,
				link: data.url,
				imgUrl: dataForWeixin.share_image += '?x-oss-process=image/resize,w_120',
				trigger: function trigger(res) {},
				success: function success(res) {
					console.log('已分享');
				},
				cancel: function cancel(res) {
					console.log('已取消');
				},
				fail: function fail(res) {
					console.log('进来了');
				}
			});
			wx.updateTimelineShareData({
				title: dataForWeixin.title,
				desc: dataForWeixin.description,
				link: data.url,
				imgUrl: dataForWeixin.share_image_zone,
				trigger: function trigger(res) {},
				success: function success(res) {
					console.log('updateTimelineShareData-已分享');
				},
				cancel: function cancel(res) {
					console.log('updateTimelineShareData-已取消');
				},
				fail: function fail(res) {
					console.log('updateTimelineShareData-进来了');
				}
			});
			wx.onMenuShareTimeline({
				title: dataForWeixin.title,
				desc: dataForWeixin.description,
				link: data.url,
				imgUrl: dataForWeixin.share_image += '?x-oss-process=image/resize,w_120',
				success: function() {
					// 用户点击了分享后执行的回调函数
				}
			})
		}
	});
	wx.error((res) => {
		console.log(JSON.stringify(res) + "微信验证失败");
	});
}
export default {
	// 获取JSSDK
	getJSSDK: getJSSDK
}